export const namespaced = true;

export const state = {
    siteCols: 'col-md-11 col-xl-8 site-max-with'
};

export const mutations = {};

export const actions = {};

export const getters = {};
